import React from 'react';
import { ChevronRight, Home } from 'lucide-react';

interface BreadcrumbNavigationProps {
  currentFolder: string;
  onNavigate: (folder: string) => void;
}

export const BreadcrumbNavigation: React.FC<BreadcrumbNavigationProps> = ({ currentFolder, onNavigate }) => {
  const folders = currentFolder.split('/').filter(Boolean);

  const displayFolders = folders.slice(1);

  return (
    <div className="flex items-center text-sm text-gray-600 mb-6">
      <button
        onClick={() => onNavigate('/')}
        className="hover:text-blue-500 transition duration-200 ease-in-out"
        aria-label="Home"
      >
        <Home size={16} />
      </button>
      {displayFolders.map((folder, index) => (
        <React.Fragment key={folder}>
          <ChevronRight size={16} className={`mx-1 ${index === 0 ? 'hidden' : ''}`} />
          <button
            onClick={() => onNavigate('/' + folders.slice(0, index + 2).join('/'))}
            className={`hover:text-blue-500 transition duration-200 ease-in-out ${index === 0 ? 'hidden' : ''}`}
          >
            {folder}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};
